<script setup>
import BoundedComponent from '@/components/BoundedComponent.vue';

const controlList = [
  {
    icon: 'dont-allow',
    text: 'Stillum símann á „Do Not Disturb“ þegar við viljum fá að vera í friði. Það má líka skilja símann eftir heima af og til.',
    alt: 'ekki leyfa',
  },
  {
    icon: 'moon',
    text: 'Nýtum svefnstillinguna „Sleep Mode“, því góður svefn er mikilvægari en tilkynningarnar.',
    alt: 'tungl',
  },
  {
    icon: 'bell',
    text: 'Slökkvum á óþarfa tilkynningum. Höfum bara kveikt á því sem skiptir máli. Veldu líka vel hverjar fá að birtast á skjánum meðan síminn er læstur, eða úrið.',
    alt: 'bjöllu',
  },
  {
    icon: 'eye',
    text: 'Skoðum „Screen Time“ og veltum fyrir okkur hvort við við séum að nýta tímann okkar vel.',
    alt: 'auga',
  },
  {
    icon: 'timer',
    text: 'Setjum tímamörk. Með App Limits getum við sett okkur raunhæf mörk með það að markmiði að gleyma okkur ekki í heilalausu skruni.',
    alt: 'tímamælir',
  },
  {
    icon: 'recursion',
    text: 'Færum öppin sem freista mest úr augsýn, eins og samfélagmiðla og leiki. Við smellum oft ómeðvitað á sama stað á skjánum. Setjum gagnleg öpp á opnunarsíðuna í staðinn.',
    alt: 'hringrás',
  },
  {
    icon: 'alert',
    text: 'Forgangsröðum. Ekki vakta alla miðla allan daginn. Ef skilaboð eru áríðandi þá sendum við SMS eða hringjum. Skoðum samfélagsmiðla á okkar forsendum þegar okkur hentar.',
    alt: 'viðvörun',
  },
  {
    icon: 'phone-rotate',
    text: 'Snúum símanum á hvolf þegar við eigum samverustundir með fólki til að forðast að líta á tilkynningar sem poppa upp. Það er sjálfsögð kurteisi.',
    alt: 'síminn snúast',
  },
  {
    icon: 'bell-off',
    text: 'Taktu hljóðið af öllum tilkynningum. Þær trufla bæði þig og aðra. Ekki síst geta þær rænt þig nætursvefni.',
    alt: 'bjalla af',
  },
];
</script>

<template>
  <BoundedComponent
    is="section"
    className="z-10"
    childClassName="bg-brown rounded-[40px] lg:rounded-6xl inner-block-px pt-10.5 lg:pt-12 xl:pt-15 pb-15 lg:pb-20 xl:pb-35"
  >
    <!-- heading -->
    <div>
      <h2 v-bounce-in class="!text-4xl lg:!text-4xl mb-4.5">
        Nýtum tímann frekar en að drepa hann!
      </h2>
      <p
        v-bounce-in
        class="text-red text-2xl lg:text-[32px] text-center mb-12.5 font-light"
      >
        Tökum stjórnina
      </p>
    </div>
    <!-- content -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-16 xl:gap-y-20 gap-x-4 xl:gap-x-7.5"
    >
      <div
        v-for="item in controlList"
        :key="item.icon"
        class="flex gap-4 items-center"
        v-bounce-in
      >
        <img
          :src="`/images/control/${item.icon}.svg`"
          :alt="item.alt"
          class="w-16 h-16"
          loading="lazy"
          width="64"
          height="64"
        />
        <p class="text-yellow text-xs">{{ item.text }}</p>
      </div>
    </div>
  </BoundedComponent>
</template>
